import type { RealtimeEventName } from '../realtime/events'
import type { TicketStatus } from './types'

// Traduz o evento de tempo real (Pusher) para o status que o bilhete passa a ter.
// Eventos que não mudam status do bilhete devolvem null: nesse caso a tela só
// recarrega (ou nem isso, se o estado local já bate).
const STATUS_BY_EVENT: Partial<Record<RealtimeEventName, TicketStatus>> = {
  TicketComplete: 'Completed',
  TicketStart: 'Started',
  TicketCancel: 'Canceled',
  TicketCalled: 'Called',
  TicketConfirm: 'Confirmed',
  TicketCheckin: 'Checked',
  TicketCheckinSmartCode: 'Checked',
  TicketReopened: 'Reopened',
}

export function ticketStatusFromEvent(eventName: string): TicketStatus | null {
  return STATUS_BY_EVENT[eventName as RealtimeEventName] ?? null
}
